/**
 *
 * A
 *
 */

import styled from 'styled-components';
import { colors } from 'globalStyles';

const A = styled.a`
  font-weight: bold;
  color: ${colors.MAIN_COLOR};

  &:hover {
    color: ${colors.MAIN_COLOR};
  }
`;

export default A;



// WEBPACK FOOTER //
// ./src/components/A/index.js